// SH updated: Grab MOQ data from data-sh-moq script tag and console log it
document.addEventListener('DOMContentLoaded', function() {
  // Get MOQ data from the script tag
  const moqScript = document.querySelector('script[data-sh-moq]');
  let moqData = null;
  
  if (moqScript) {
    try {
      moqData = JSON.parse(moqScript.textContent);
      console.log('SH MOQ Data:', moqData);
      
      // Log individual properties for easier debugging
      console.log('MOQ Value:', moqData.moq);
      console.log('Product ID:', moqData.product_id);
      
      // Check if MOQ is valid
      if (moqData.moq && moqData.moq !== '' && moqData.moq !== '0') {
        console.log('Valid MOQ found:', moqData.moq);
      } else {
        console.log('No valid MOQ found or MOQ is empty/0');
        return; // Exit early if no valid MOQ
      }
      
    } catch (error) {
      console.error('Error parsing MOQ data:', error);
      console.log('Raw script content:', moqScript.textContent);
      return; // Exit early if parsing fails
    }
  } else {
    console.log('No MOQ script tag found');
    return; // Exit early if no script tag
  }

  // SH updated: Observe and count how many times the qty break grid is rendered
  (function initQtyBreakGridObserver() {
    const selector = 'table.shappify_qb_grid';
    let renderEventCount = 0;
    const seen = new WeakSet();

    // Scan a root for new tables and count unique appearances
    function scanAndCount(root) {
      if (!root || !(root instanceof Element) && root !== document) return;
      const scope = root === document ? document : root;
      const tables = scope.querySelectorAll(selector);
      tables.forEach((table) => {
        if (!seen.has(table)) {
          seen.add(table);
          renderEventCount += 1;
          console.log('SH qty grid render event #' + renderEventCount, table);
          
          // SH updated: Find and modify the "Buy 1" row
          const buy1Row = findAndModifyBuy1Row(table);
          if (buy1Row) {
            console.log('SH Buy 1 row found and modified in render #' + renderEventCount + ':', buy1Row);
            console.log('SH Modified row HTML:', buy1Row.outerHTML);
          } else {
            console.log('SH No "Buy 1" row found in render #' + renderEventCount);
          }
        }
      });
    }

    // SH updated: Helper function to find and modify the "Buy 1" row in a table
    function findAndModifyBuy1Row(table) {
      if (!table || !moqData || !moqData.moq) return null;
      
      const rows = table.querySelectorAll('tbody tr');
      for (const row of rows) {
        const cells = row.querySelectorAll('td');
        if (cells.length >= 1) {
          const firstCell = cells[0];
          if (firstCell) {
            // Normalize text: trim whitespace, convert to lowercase, and collapse multiple spaces
            const cellText = firstCell.textContent.trim().toLowerCase().replace(/\s+/g, ' ');
            
            // Check for various "buy 1" patterns (case-insensitive, flexible spacing)
            if (cellText === 'buy 1' || 
                cellText === 'buy1' || 
                cellText.startsWith('buy 1') || 
                cellText.includes('buy 1')) {
              
              // SH updated: Change "Buy 1" to "Buy [MOQ value]"
              const moqValue = moqData.moq;
              firstCell.textContent = `Buy ${moqValue}`;

              // SH updated: Also update the price in the next td by multiplying with MOQ
              if (cells.length >= 2) {
                const priceCell = cells[1];
                // Avoid double application if observer re-fires
                if (!priceCell || priceCell.getAttribute('data-sh-moq-adjusted') === 'true') {
                  // already adjusted; skip
                } else {
                  const raw = priceCell.textContent.trim();
                  // Capture currency prefix, numeric portion, and trailing text (e.g., ' ea')
                  const match = raw.match(/^(\D*?)\s*([0-9.,]+)\s*(.*)$/);
                  if (match) {
                    const prefix = match[1] || '';
                    const numStr = match[2] || '';
                    const suffix = match[3] || '';
                    // Normalize number (remove commas)
                    const unit = parseFloat(numStr.replace(/,/g, ''));
                    const qty = parseFloat(String(moqValue));
                    if (!isNaN(unit) && !isNaN(qty)) {
                      const total = (unit * qty).toFixed(2);
                      // Preserve thousands separators similar to input if it had commas
                      const formatted = Number(total).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      priceCell.textContent = `${prefix}${formatted} ${suffix}`.trim();
                      priceCell.setAttribute('data-sh-moq-adjusted', 'true');
                      console.log(`SH Updated price to ${priceCell.textContent} using MOQ ${qty}`);
                    }
                  }
                }
              }

              console.log(`SH Modified "Buy 1" to "Buy ${moqValue}" in render #${renderEventCount}`);
              return row;
            }
          }
        }
      }
      return null;
    }

    // Initial scan in case the table is already present
    scanAndCount(document);

    // MutationObserver to detect future renders (app re-injections)
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            // If the added node itself is the table
            if (node.matches && node.matches(selector)) {
              if (!seen.has(node)) {
                seen.add(node);
                renderEventCount += 1;
                console.log('SH qty grid render event #' + renderEventCount, node);
                
                // SH updated: Find and modify the "Buy 1" row
                const buy1Row = findAndModifyBuy1Row(node);
                if (buy1Row) {
                  console.log('SH Buy 1 row found and modified in render #' + renderEventCount + ':', buy1Row);
                  console.log('SH Modified row HTML:', buy1Row.outerHTML);
                } else {
                  console.log('SH No "Buy 1" row found in render #' + renderEventCount);
                }
              }
            }
            // Or if the table exists within the added subtree
            scanAndCount(node);
          });
        }
      }
    });

    try {
      observer.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true
      });
      console.log('SH qty grid observer initialized');
    } catch (e) {
      console.warn('SH qty grid observer failed to initialize:', e);
    }

    // SH updated: Show table after mutations complete
    function showQuantityBreakGrid() {
      const tables = document.querySelectorAll('table.shappify_qb_grid');
      tables.forEach(table => {
        table.style.display = 'table';
        console.log('SH Made qty grid visible:', table);
      });
    }

    // Optional: Log a summary after a window to observe typical app injections
    setTimeout(function() {
      console.log('SH qty grid total render events observed (10s):', renderEventCount);
      showQuantityBreakGrid();
    }, 10000);

    // SH updated: Also show table after each successful modification
    const originalScanAndCount = scanAndCount;
    scanAndCount = function(root) {
      const result = originalScanAndCount(root);
      // Show table after any successful scan
      setTimeout(showQuantityBreakGrid, 100);
      return result;
    };
  })();
});
